/**
 * Shared utilities for merging candle data
 * Consolidates merge logic used by both candleCache and marketsSlice
 */
import { resolveTimestampFromCandle as resolveTimestamp } from './candleUtils';

/**
 * Extract date string from candle for caching purposes
 */
export function extractCandleDate(candle) {
  const timestamp = resolveTimestamp(candle);
  if (timestamp === null) {
    return null;
  }
  
  try {
    return new Date(timestamp).toISOString();
  } catch (error) {
    return null;
  }
}

/**
 * Merge existing candles with new incremental candles
 * Deduplicates by timestamp and sorts chronologically
 */
export function mergeCandles(existingCandles, newCandles) {
  if (!Array.isArray(existingCandles)) existingCandles = [];
  if (!Array.isArray(newCandles)) newCandles = [];

  const candleMap = new Map();
  
  existingCandles.forEach(candle => {
    const timestamp = resolveTimestamp(candle);
    if (timestamp !== null) {
      candleMap.set(timestamp, candle);
    }
  });

  newCandles.forEach(candle => {
    const timestamp = resolveTimestamp(candle);
    if (timestamp !== null) {
      candleMap.set(timestamp, candle);
    }
  });

  const mergedCandles = Array.from(candleMap.values());
  mergedCandles.sort((a, b) => {
    const timestampA = resolveTimestamp(a);
    const timestampB = resolveTimestamp(b);
    return (timestampA || 0) - (timestampB || 0);
  });

  return mergedCandles;
}
